import { InputGroup } from '@sb1/ffe-form-react';
import { SearchableDropdown } from '@sb1/ffe-searchable-dropdown-react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormActions } from '../../../utils/form-helpers';
import filtersFormConfig from '../filters-form-config';

const { setFormField } = getFormActions(filtersFormConfig);

export const OrganizationCauseDropdown = ({ list }) => {
    const dispatch = useDispatch();
    const { templateId } = useSelector((state) => state.filtersForm);

    const id = 'cause-dropdown';
    const labelId = `${id}-label`;
    const selected = list?.find((item) => item.template_id === parseInt(templateId, 10));

    const onChange = (value) => {
        dispatch(setFormField('templateId', value));
    };

    if (!list) {
        return null;
    }

    const listWithReset = selected ? [{ title: 'Alle spleiser', template_id: null }, ...list] : list;

    return (
        <InputGroup label="Velg aksjon" labelId={labelId}>
            <SearchableDropdown
                id={id}
                labelledById={labelId}
                inputProps={{ placeholder: 'Alle spleiser' }}
                dropdownAttributes={['title']}
                dropdownList={listWithReset}
                noMatch={{ text: 'Søket ga ingen treff' }}
                onChange={(item) => onChange(item.template_id)}
                searchAttributes={['title']}
                locale="nb"
                selectedItem={selected}
            />
        </InputGroup>
    );
};
